const micrositeGalleryDefaultState = {
  data: {},
  loading: false,
  error: false,
  success: false,
  successMessage: '',
  errorMessage: null,
};

const micrositeGalleryReducer = (state = micrositeGalleryDefaultState, action) => {
  switch(action.type) {
    case 'START_GET_MICROSITE_GALLERY':
      return {
        ...state,
        loading: true,
        error: false,
        errorMessage: null,
        successMessage: '',
      };
    case 'GET_MICROSITE_GALLERY_SUCCESS':
      return {
        ...state,
        data: action.micrositeGallery,
        loading: false,
        error: false,
        errorMessage: null,
      };
    case 'START_CREATE_MICROSITE_GALLERY':
      return {
        ...state,
        loading: true,
        error: false,
        errorMessage: null,
        successMessage: '',
      };
    case 'CREATE_MICROSITE_GALLERY_SUCCESS':
      return {
        ...state,
        data: action.micrositeGallery,
        loading: false,
        success: true,
        error: false,
        errorMessage: null,
        successMessage: 'Your account has been created!',
      };
    case 'START_MICROSITE_GALLERY_UPDATE':
      return {
        ...state,
        loading: true,
        error: false,
        errorMessage: null,
        successMessage: '',
      };
    case 'MICROSITE_GALLERY_UPDATE_SUCCESS':
      return {
        ...state,
        data: {
          ...state.data,
          ...action.micrositeGallery
        },
        loading: false,
        success: true,
        error: false,
        errorMessage: null,
        successMessage: '',
      };
    case 'SHOW_ERROR':
      return {
        ...state,
        loading: false,
        error: true,
        successMessage: '',
        errorMessage: action.errorMessage
      };
    default:
      return state;
  }
};

export default micrositeGalleryReducer;
